import {createStore,combineReducers} from 'redux'
import camping from './reducers/camping'
import dormis from './reducers/dormis'
const reducer = combineReducers({camping,dormis})

const store= createStore(reducer)

export default store